import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const CLAIM_AGENCY_MUTATION = gql`
  mutation ClaimAgency($teamId: uuid!) {
    claim_agency(team_id: $teamId) {
      success
    }
  }
`;

const START_TRIAL_MUTATION = gql`
  mutation StartTrial {
    start_trial {
      success
    }
  }
`;

const CLAIM_AGENT_MUTATION = gql`
  mutation ClaimAgent {
    claim_agent {
      success
    }
  }
`;

export const useStartTrial = (
  onSuccess?: () => void,
  onError?: (message: string) => void,
) => {
  const handleSuccess = () =>
    onSuccess != null ? onSuccess() : window.location.reload();

  const handleError = (err: Error) => {
    const message = err.message ?? 'An error occurred. Please try again.';
    if (onError != null) {
      onError(message);
    } else {
      console.error('[useStartTrial]', message);
    }
  };

  const [claimAgencyMutate, { loading: claimLoading }] = useMutation(
    CLAIM_AGENCY_MUTATION,
    { onCompleted: handleSuccess, onError: handleError },
  );
  const [startTrialMutate, { loading: trialLoading }] = useMutation(
    START_TRIAL_MUTATION,
    { onCompleted: handleSuccess, onError: handleError },
  );
  const [claimAgentMutate, { loading: claimAgentLoading }] = useMutation(
    CLAIM_AGENT_MUTATION,
    { onCompleted: handleSuccess, onError: handleError },
  );

  // Agency claim → claim_agency (needs teamId). Pure trial (plans page) →
  // start_trial. Agent claim is a distinct action (claim_agent), exposed below.
  const startTrial = (teamId?: string) => {
    if (teamId != null) {
      return claimAgencyMutate({ variables: { teamId } });
    }
    return startTrialMutate();
  };

  const claimAgent = () => claimAgentMutate();

  return {
    startTrial,
    claimAgent,
    loading: claimLoading || trialLoading || claimAgentLoading,
  };
};
